/**
 * Created by shaun on 16/09/2017.
 */

import Vue from 'vue';

import {EMPTY, READY, LOADING, UPDATING, ERROR} from 'module/constants';
import common from 'module/common';
import {mapFieldMutation} from 'module/mapField';
import Moment from "moment/moment";

const SET_STATE = 'setState';
const SET_APP = 'setApp';
const SET_CONFIG = 'setConfig';

// initial state
const state = {
  state: EMPTY,
  app: null,
  config: null
};

//actions
const actions = {
  app({commit, dispatch, rootGetters}, app) {
    return new Promise((resolve, reject) => {
      commit(SET_STATE, LOADING);
      commit(SET_APP, app);
      common
        .httpGet('appConfig')
        .idToken(rootGetters['user/idToken']() || null)
        .query({app})
        .then((res) => {
          commit(SET_STATE, READY);
          commit(SET_CONFIG, res.data);
          resolve(res.data);
        }, (error) => {
          console.log('Error', error);
          dispatch('error/error', error, {root: true});
          commit(SET_STATE, ERROR);
          reject();
        });
    });
  },
  save({commit, dispatch, state, rootGetters}, config) {
    return new Promise((resolve, reject) => {
      commit(SET_STATE, UPDATING);
      common
        .httpPost('appConfig')
        .data({
          app: state.app,
          config: config || state.config,
          idToken: rootGetters['user/idToken']()
        })
        .then((res) => {
          commit(SET_STATE, READY);
          commit(SET_CONFIG, res.data);
          resolve(res.data);
        }, (error) => {
          console.log('Error', error);
          dispatch('error/error', error, {root: true});
          commit(SET_STATE, ERROR);
          reject();
        });
    });
  }
};

//getters
const getters = {};

// mutations
const mutations = {
  [SET_STATE](state, newState) {
    state.state = newState;
  },
  [SET_APP](state, app) {
    state.app = app;
  },
  [SET_CONFIG](state, config) {
    state.config = config;
  }
};

export default {
  state,
  actions,
  getters,
  mutations
}